export default __webpack_public_path__ + "static/media/devesh.64e33b1d.jpg";